var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "preview-inline",
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_vm._t("default"), _c('v-menu', {
    attrs: {
      "position-x": _vm.menuX,
      "position-y": _vm.menuY,
      "absolute": "",
      "offset-y": "",
      "close-on-content-click": false,
      "max-width": "800",
      "min-width": "700"
    },
    model: {
      value: _vm.showMenu,
      callback: function callback($$v) {
        _vm.showMenu = $$v;
      },
      expression: "showMenu"
    }
  }, [_c('v-card', {
    on: {
      "mouseenter": _vm.onMenuEnter,
      "mouseleave": _vm.onMenuLeave
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 pb-2"
  }, [_vm.loading ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "size": "20"
    }
  }), _c('div', {
    staticClass: "text-caption mt-1"
  }, [_vm._v(_vm._s(_vm.$translate('loading')))])], 1) : _vm.items && _vm.items.length > 0 ? _c('div', [_vm.showInfos && _vm.order ? _c('div', {
    staticClass: "pa-4 pb-0"
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center"
  }, [_c('div', [_c('router-link', {
    staticClass: "text-subtitle-2 font-weight-bold text-decoration-none",
    attrs: {
      "to": {
        name: 'providerorder',
        params: {
          providerorder_id: _vm.order.id
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.order.order_id) + " ")]), _vm.order.archived ? [_vm._v(" - "), _c('i', [_vm._v(_vm._s(_vm.$translate('archived')))])] : _vm._e()], 2), _c('v-chip', {
    attrs: {
      "small": "",
      "color": _vm.$utils.getProviderOrderStatusColor(_vm.order),
      "outlined": _vm.order.readonly
    }
  }, [_vm._v(" " + _vm._s(_vm.$utils.getProviderOrderStatusText(_vm.order)) + " ")])], 1), _c('div', {
    staticClass: "d-flex justify-space-between mt-2 mb-2"
  }, [_c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm.order.seller_entity !== _vm.current_entity_id && _vm.order.seller_entity_data ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-store")]), _vm._v(" " + _vm._s(_vm.order.seller_entity_data.name) + " ")], 1) : _vm._e(), _vm.order.buyer_data ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-account")]), _vm._v(" " + _vm._s(_vm.order.buyer_data.name) + " ")], 1) : _vm._e(), _vm.order.deliverysite_data ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-map-marker")]), _vm._v(" " + _vm._s(_vm.order.deliverysite_data.name) + " ")], 1) : _vm._e(), _vm.order.delivery_date ? _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-calendar")]), _vm._v(" " + _vm._s(_vm.$moment(_vm.order.delivery_date).format('ll')) + " ")], 1) : _vm._e()]), _c('div', {
    staticClass: "text-caption grey--text text-right"
  }, [_vm.order.total_amount_excl_vat !== null ? _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$utils.price(_vm.order.total_amount_excl_vat)) + " " + _vm._s(_vm.$translate('excl_vat')))]), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm.$utils.price(_vm.order.total_amount_incl_vat)) + " " + _vm._s(_vm.$translate('incl_vat')) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-package-variant")]), _vm._v(" " + _vm._s(_vm.order.items_count) + " " + _vm._s(_vm.$translate('items')) + " ")], 1)])]), _c('v-divider', {
    staticClass: "mb-2"
  })], 1) : _vm._e(), _c('div', {
    staticClass: "order-items-list",
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto",
      "overflow-x": "auto"
    }
  }, [_c('v-simple-table', {
    staticClass: "no-wrap-table",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$translate('upc')))]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$translate('product')))]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$translate('manufacturer')))]), _c('th', {
          staticClass: "text-right"
        }, [_vm._v(_vm._s(_vm.$translate('quantity')))])])]), _c('tbody', _vm._l(_vm.items, function (item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', {
            staticClass: "text-left"
          }, [_vm._v(" " + _vm._s(_vm.getProductUpc(item)) + " ")]), _c('td', {
            staticClass: "text-left font-weight-bold"
          }, [_vm._v(" " + _vm._s(_vm.getProductName(item)) + " ")]), _c('td', {
            staticClass: "text-left"
          }, [_vm._v(" " + _vm._s(_vm.getProductManufacturer(item)) + " ")]), _c('td', {
            staticClass: "text-right"
          }, [_c('v-chip', {
            attrs: {
              "x-small": "",
              "outlined": ""
            }
          }, [_vm._v(" " + _vm._s(_vm.$utils.formatSaleQuantityDisplay(item)) + " ")])], 1)]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1)]) : _vm.items && _vm.items.length === 0 ? _c('div', {
    staticClass: "text-body-2 pa-4"
  }, [_vm._v(" " + _vm._s(_vm.$translate('no_products_found')) + " ")]) : _vm._e()])], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }